import CalendarFallbackIcon from '@components/shared/CalendarFallbackIcon'
import { hasNationalCalendarFallback } from '@components/shared/calendarFallback'

function formatDate(value) {
  if (!value) return 'Não calculado'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)
  return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeZone: 'UTC' }).format(date)
}

function formatPeriod(deadline) {
  const units = { BUSINESS_DAYS: 'dias úteis', CALENDAR_DAYS: 'dias corridos', HOURS: 'horas', DAYS: 'dias' }
  return `${deadline.deadlineAmount} ${units[deadline.deadlineUnit] || deadline.deadlineUnit || ''}`.trim()
}

export default function DeadlineResolvedDeadlinesCard({ deadlines = [] }) {
  return (
    <section className="rules-card deadline-result-section">
      <div className="rules-card-header">
        <div>
          <h3>Prazos resolvidos pelo motor</h3>
          <p>Lista retornada em <code>resolvedDeadlines</code>.</p>
        </div>
      </div>
      <div className="rules-card-body">
        {deadlines.length ? (
          <div className="deadline-task-list">
            {deadlines.map((deadline, index) => {
              const explicitOverride = deadline.evidence?.some(item => item.type === 'EXPLICIT_DEADLINE_OVERRIDES_RULE') === true
              return (
                <article className="deadline-task-item" key={`${deadline.actionCode || 'deadline'}-${index}`}>
                  <div className="deadline-task-header">
                    <div>
                      <h4>{explicitOverride
                        ? `Prazo expresso na publicação: ${formatPeriod(deadline)}`
                        : deadline.deadlineRuleName || deadline.deadlineRuleCode || 'Regra não informada'}</h4>
                      <span>{deadline.actionName || deadline.actionCode || 'Ação não informada'}</span>
                    </div>
                    {deadline.requiresHumanReview ? <span className="status-badge is-warning">Revisão</span> : null}
                  </div>
                  <dl className="deadline-task-grid">
                    <div><dt>Quantidade</dt><dd>{deadline.deadlineAmount ?? 'Não informada'}</dd></div>
                    <div><dt>Unidade</dt><dd>{deadline.deadlineUnit || 'Não informada'}</dd></div>
                    <div><dt>Data inicial</dt><dd>{formatDate(deadline.initialDate)}</dd></div>
                    <div><dt>Vencimento</dt><dd>{formatDate(deadline.dueDate)}{deadline.dueDate && <CalendarFallbackIcon source={deadline} />}</dd></div>
                    <div><dt>Estratégia inicial</dt><dd>{deadline.initialTermStrategy || 'Não informada'}</dd></div>
                    <div><dt>Calendário</dt><dd>{hasNationalCalendarFallback(deadline) ? 'Calendário nacional' : deadline.calendarUsed || 'Não informado'}</dd></div>
                  </dl>
                  {explicitOverride ? (
                    <p>Regra de referência: {deadline.deadlineRuleName || deadline.deadlineRuleCode || 'Regra cadastrada'}. A quantidade expressa na publicação foi aplicada ao cálculo.</p>
                  ) : null}
                  {deadline.reviewReason ? <p className="deadline-review-reason">{deadline.reviewReason}</p> : null}
                </article>
              )
            })}
          </div>
        ) : <p>Nenhum prazo resolvido foi retornado.</p>}
      </div>
    </section>
  )
}
